module.exports = __webpack_public_path__ + "0af5d249/img/rename-icon.de4e673d.svg";